import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { syncSignupCouponFromLocation } from '../services/signupCoupon';

export const SignupCouponCapture: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    syncSignupCouponFromLocation(pathname, search);
  }, [pathname, search]);

  return null;
};
